import $cookies from '@/plugins/vueCookies'

export const referreCodeName = 'bn_referral_code'

export const saveUtmAndReferral = (query) => {
  const utmPrefix = 'utm_'
  const utmKeys = Object.keys(query).filter((k) => k.indexOf(utmPrefix) > -1)
  if (utmKeys.length > 0) {
    const utm = {}
    for (const k of utmKeys) {
      utm[k.replace(utmPrefix, '')] = query[k]
    }
    $cookies.set('bn_utm', JSON.stringify(utm), 0)
  }

  // URL에 referral_code가 있으면 쿠키에 저장
  if (query.referral_code) {
    $cookies.set(referreCodeName, query.referral_code, 0) // 'bn_referral_code'로 쿠키에 저장
  }
}

export default async (to, from, next) => {
  saveUtmAndReferral(to.query)
  next()
}
